import { UserIdChannel } from './@types.js';

export interface LinkUserIDResponse {
  id: string;
  status: 'LINKED' | 'NEW' | 'CONFLICT' | 'UNCHANGED';
}

export class IDServiceClient {
  constructor(private baseURL: string) {}

  async getUserId(channels: Array<UserIdChannel>): Promise<string> {
    const response = await fetch(`${this.baseURL}/u/id`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(channels),
    });
    const payload = await response.json();
    return payload.id;
  }

  async linkUserId(userId: string, channels: Array<UserIdChannel>): Promise<LinkUserIDResponse> {
    const response = await fetch(`${this.baseURL}/u/id/${userId}/link`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(channels),
    });
    return await response.json();
  }
}
